import { defineListFilter } from '../engine/descriptor';
import { FilterId, FilterType } from '../types/filters';

export const genderDescriptor = defineListFilter({
  definition: {
    id: FilterId.GENDER,
    name: 'Gender',
    selectionListId: 'gender',
    selections: [],
    type: FilterType.LIST,
    isVisible: true,
  },
  multi: { id: FilterId.MULTI_GENDER },
});
